"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RPC_ACTION;
(function (RPC_ACTION) {
    RPC_ACTION[RPC_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    RPC_ACTION[RPC_ACTION["ERROR"] = 1] = "ERROR";
    RPC_ACTION[RPC_ACTION["REQUEST"] = 2] = "REQUEST";
    RPC_ACTION[RPC_ACTION["ACCEPT"] = 4] = "ACCEPT";
    RPC_ACTION[RPC_ACTION["RESPONSE"] = 5] = "RESPONSE";
    RPC_ACTION[RPC_ACTION["REJECT"] = 6] = "REJECT";
    RPC_ACTION[RPC_ACTION["REQUEST_ERROR"] = 7] = "REQUEST_ERROR";
    RPC_ACTION[RPC_ACTION["PROVIDE"] = 8] = "PROVIDE";
    RPC_ACTION[RPC_ACTION["UNPROVIDE"] = 9] = "UNPROVIDE";
    RPC_ACTION[RPC_ACTION["NO_RPC_PROVIDER"] = 100] = "NO_RPC_PROVIDER";
    RPC_ACTION[RPC_ACTION["ACCEPT_TIMEOUT"] = 101] = "ACCEPT_TIMEOUT";
    RPC_ACTION[RPC_ACTION["MULTIPLE_ACCEPT"] = 102] = "MULTIPLE_ACCEPT";
    RPC_ACTION[RPC_ACTION["INVALID_RPC_CORRELATION_ID"] = 103] = "INVALID_RPC_CORRELATION_ID";
    RPC_ACTION[RPC_ACTION["RESPONSE_TIMEOUT"] = 104] = "RESPONSE_TIMEOUT";
    RPC_ACTION[RPC_ACTION["MULTIPLE_RESPONSE"] = 105] = "MULTIPLE_RESPONSE";
    RPC_ACTION[RPC_ACTION["MESSAGE_PERMISSION_ERROR"] = 106] = "MESSAGE_PERMISSION_ERROR";
    RPC_ACTION[RPC_ACTION["MESSAGE_DENIED"] = 107] = "MESSAGE_DENIED";
    RPC_ACTION[RPC_ACTION["INVALID_MESSAGE_DATA"] = 108] = "INVALID_MESSAGE_DATA";
    RPC_ACTION[RPC_ACTION["MULTIPLE_PROVIDERS"] = 109] = "MULTIPLE_PROVIDERS";
    RPC_ACTION[RPC_ACTION["NOT_PROVIDED"] = 110] = "NOT_PROVIDED";
})(RPC_ACTION = exports.RPC_ACTION || (exports.RPC_ACTION = {}));
//# sourceMappingURL=rpc.js.map